module.exports = __webpack_public_path__ + "img/1900m.b7e6e198.png";